import api from './api';

export interface TranscriptionResponse {
  transcription_id: string;
  transcript: string;
  duration_seconds: number;
  language: string;
}

export async function transcribeAudio(audioBlob: Blob): Promise<TranscriptionResponse> {
  const formData = new FormData();
  formData.append('audio', audioBlob);

  const response = await api.post<TranscriptionResponse>(
    '/api/v2/chat/transcribe',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );

  return response.data;
}
